import React from 'react';
import styled from 'styled-components';

const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
`;

const Chip = styled.button`
  padding: 12px 16px;
  border-radius: 8px;
  border: none;
  background: ${({ selected, theme }) =>
    selected ? theme.colors.primary || '#1976d2' : '#f0f0f0'};
  color: ${({ selected }) => (selected ? '#fff' : '#333')};
  cursor: pointer;
  font-size: 18px;
  transition: background 0.2s;
  outline: none;

  &:hover {
    background: ${({ selected, theme }) =>
      selected ? theme.colors.primary : '#e0e0e0'};
  }
`;

export const TierOptionChoice = ({
  tierOptions,
  onTierSelected,
  selectedTier,
}) => {
  return (
    <ChipContainer>
      {tierOptions.map((option) => (
        <Chip
          key={option.value}
          selected={selectedTier === option}
          onClick={() => onTierSelected(option)}
        >
          {option.label}
        </Chip>
      ))}
    </ChipContainer>
  );
};
